var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.93 14.434 4.19-4.19a1.059 1.059 0 0 0-1.5-1.5l-4.19 4.19-4.19-4.19a1.06 1.06 0 1 0-1.5 1.5l4.19 4.19-4.19 4.19a1.06 1.06 0 1 0 1.5 1.5l4.19-4.19 4.19 4.19a1.06 1.06 0 1 0 1.5-1.5z",
    transform: "translate(-8.434 -8.435)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.135128a67cca2ec20fd17bede8fcc1c8.svg";
export { ForwardRef as ReactComponent };